import { render } from "./dineIn.vue?vue&type=template&id=1632a3bd&scoped=true"
import script from "./dineIn.vue?vue&type=script&lang=js"
export * from "./dineIn.vue?vue&type=script&lang=js"

import "./dineIn.vue?vue&type=style&index=0&id=1632a3bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1632a3bd"]])

export default __exports__